import type { ArticleDetailApiData, ArticleDetailApi } from '~/server/types'

export const useArticleStore = defineStore('Article', () => {
  const { config } = storeToRefs(useStore())
  const articleDetail = ref<ArticleDetailApiData>()
  async function fetchArticleDetail(id: number) {
    const res = await useFetch(`/api/article/detail?id=${id}`)
    articleDetail.value = (res.data.value as ArticleDetailApi).data
    return articleDetail.value
  }
  async function fetchArticleList(
    rule: number,
    page: number,
    size: number,
    type: 'default' | 'category' | 'all' = 'default',
    categoryId: string | number = -1
  ) {
    try {
      const res = await useAsyncData('get', () =>
        $fetch(
          `/api/article/list?lang_id=${config.value.id}&rule=${rule}&page=${page}&size=${size}&type=${type}&category_id=${categoryId}`
        )
      )
      return res.data.value.data
    } catch (error) {
      console.error('Error:', error)
    }
  }
  return {
    articleDetail,
    fetchArticleDetail,
    fetchArticleList
  }
})
